export default __webpack_public_path__ + "static/media/aphrodite.5e3d2a02.gif";